import { TFunction } from "next-i18next";
import { EnumCommentStatus } from "src/api/client/comment-v2.api.types";
import { TComment } from "src/components/common/comments-area/comment/comment.types";
import { stripHtml } from "src/utils/html/strip-html";

type TParentPreviewMessage = {
    comments: TComment[] | undefined;
    parentCommentId: TComment["parentCommentId"];
    t: TFunction;
};

export type ParentPreviewInfo = {
    deleted?: boolean;
    message?: string;
};

export const getParentPreviewInfo = ({ comments, parentCommentId, t }: TParentPreviewMessage): ParentPreviewInfo | undefined => {
    const parentComment = comments?.find(c => c.commentId === parentCommentId);

    if (!parentComment) {
        return undefined;
    }

    if (parentComment.status === EnumCommentStatus.Deleted) {
        return {
            deleted: true,
            message: parentComment.deletedByWikifolio ? t("title.comment-was-deleted-by-wikifolio") : t("title.comment-was-deleted-by-trader"),
        };
    }

    return {
        deleted: false,
        message: stripHtml({ html: parentComment.message }),
    };
};
